import React, { useState, ChangeEvent } from 'react';
import { TextField, Button, Box, Typography, IconButton } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';

import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import { makeStyles } from '@material-ui/core/styles';
import EmojiPicker from './EmojiPicker';
import { Stamp } from '../../../models/DailyReport/StampModel';
import { CommonStamp } from '../../../constants/Stamp';

const useStyles = makeStyles(() => ({
  container: {
    border: '1px solid #333',
    padding: '16px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  inputArea: {
    width: '100%',
    marginTop: '8px',
    '& textarea': {
      resize: 'none',
    },
  },
  buttonContainer: {
    position: 'absolute',
    bottom: '16px',
    right: '16px',
    display: 'flex',
    gap: '8px',
  },
  sendButton: {
    backgroundColor: '#3f51b5',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#303f9f',
    },
  },
  emojiButton: {
    marginBottom: '1px',
    padding: '0px 5px',
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  charCount: {
    fontSize: '12px',
    color: '#555',
  },
  likeButton: {
    padding: '5px',
    margin: '2px',
    backgroundColor: '#e0f7fa',
    borderRadius: '5px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#b2ebf2',
    },
  },
}));

interface CommentInputProps {
  comment: string;
  max?: number;
  onChange: (comment: string) => void;
  onSend: () => void;
  onSendStamp: (stamp: Stamp) => void;
}

const CommentInput = (props: CommentInputProps) => {
  const { comment, max, onChange, onSend, onSendStamp } = props;
  const classes = useStyles();
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const maxCharCount = max;

  const handleCommentChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleSendClick = () => {
    onSend();
  };

  const handleStampSelect = (stamp: Stamp) => {
    console.log(stamp);
    onSendStamp(stamp);
  };

  const commentLength = comment.split('\n').reduce((acc, line) => acc + line.length, 0);

  return (
    <Box className={classes.container}>
      <Typography className={classes.charCount}>
        (入力文字数 {commentLength}文字 / {maxCharCount}文字)
        <IconButton
          size="small"
          className={classes.likeButton}
          style={{ marginLeft: '8px' }}
          onClick={() => onSendStamp(CommonStamp.Good)}
        >
          <ThumbUpIcon fontSize="small" />
          <Typography className={classes.charCount} style={{ marginLeft: '8px' }}>
            いいねスタンプを送る
          </Typography>
        </IconButton>
      </Typography>
      <TextField
        className={classes.inputArea}
        multiline
        minRows={4}
        maxRows={10}
        variant="outlined"
        placeholder="コメントを入力してください..."
        value={comment}
        onChange={handleCommentChange}
        inputProps={{ maxLength: maxCharCount }}
      />
      <div className={classes.buttonContainer}>
        <IconButton className={classes.emojiButton} onClick={() => setIsEmojiPickerOpen(true)}>
          <EmojiEmotionsIcon />
        </IconButton>
        <Button
          variant="contained"
          className={classes.sendButton}
          endIcon={<SendIcon />}
          onClick={handleSendClick}
          disabled={comment.length === 0}
        >
          送信
        </Button>
      </div>
      <EmojiPicker
        open={isEmojiPickerOpen}
        onClose={() => setIsEmojiPickerOpen(false)}
        onStampSelect={handleStampSelect}
      />
    </Box>
  );
};

export default CommentInput;
